module.exports = __webpack_public_path__ + "static/media/bg-brand.55207ef2.jpg";